<template>
  <LocalizedLink :to="target" class="position-absolute" :class="arrowClass" >
    <img :src="arrowClass == 'arrow-right' ? require('../assets/imgs/arrow-right.png'): require('../assets/imgs/arrow-left.png')" class="dlg-arrow">
	</LocalizedLink>
</template>

<script>
import LocalizedLink from '@/components/LocalizedLink'

export default {
  name: "arrow",
	components: {
		LocalizedLink
	},
  props: {
    arrowClass: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.arrow-right {
  position: absolute;
  top: 3.5em;
  right: -1.5em;
}

.arrow-left {
  position: absolute;
  top: 3.5em;
  left: -1.5em;
}
img:active {
  transform: translateY(4px);
  transform: scale(0.9);
}
@media (max-width: 729px) {
  img:focus, img:active {
    transform: translateY(4px);
    transform: scale(0.9);
  }
}
@media (max-width: 414px) {
  .dlg-arrow {
    width: 50px;
  }
  .arrow-left {
    left: 0em;
    top: 3.5em;
  }
  .arrow-right {
    right: 0em;
    top: 3.5em;
  }
}
</style>
